export default { sha: 'c3a293c3cc529b836b890d795bc5513e5cba982b', buildNumber: 'undefined' }
